import React from "react";
import NewsItems from "../components/NewsItems";

export default function NewsList() {
    return (
        <div className="News">
            <div className="AppContainer">
                <h1 className="SectionTitle">News</h1>
                <NewsItems />
            </div>
        </div>
    );
}
